import { doc, setDoc } from "firebase/firestore";
import { type FC, useState } from "react";
import { db } from "../../../../../firebase/client";
import { usePollVotes } from "../../../../../hooks/use-poll-votes";
import type { Poll } from "../../../../../types/polls.types";
import Button from "../../../../button/button";
import RadioGroup from "../../../../radio-group/radio-group";
import * as CSS from "./poll-display.styles";

type PollDisplayProps = {
	poll: Poll;
	broadcastId: string;
	uid: string;
	includePadding?: boolean;
};

const PollDisplay: FC<PollDisplayProps> = ({
	poll,
	uid,
	broadcastId,
	includePadding = true,
}) => {
	const [selectedOption, setSelectedOption] = useState<string | null>(null);

	const { question, options, ended } = poll;

	const { votesByUser } = usePollVotes(broadcastId, poll?.id ?? null);
	const myVote = uid ? votesByUser[uid] : undefined;
	const hasVoted = myVote !== undefined;
	const myVoteOptionId =
		myVote !== undefined ? `option_${poll.options.indexOf(myVote)}` : null;

	const handleSubmitVote = () => {
		if (!broadcastId || !uid || selectedOption === null) return;

		const option = poll.options[Number(selectedOption.replace("option_", ""))];
		if (!option) return;

		setDoc(doc(db, "broadcasts", broadcastId, "polls", poll.id, "votes", uid), {
			option,
		}).catch(console.error);
	};

	return (
		<div style={{ marginLeft: includePadding ? 44 : 0 }}>
			<CSS.PollQuestion>{question}</CSS.PollQuestion>
			<CSS.PollOptions>
				<RadioGroup
					vertical
					activeId={hasVoted ? myVoteOptionId : selectedOption}
					onChange={(id) => setSelectedOption(id)}
					items={options.map((option, index) => ({
						disabled: hasVoted,
						id: `option_${index}`,
						label: option,
					}))}
				/>
			</CSS.PollOptions>
			{!ended && !hasVoted && (
				<div style={{ display: "flex", flexDirection: "row-reverse" }}>
					<Button onClick={handleSubmitVote} disabled={selectedOption === null}>
						Submit vote
					</Button>
				</div>
			)}
		</div>
	);
};

export default PollDisplay;
